import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";

const initialState = {
  errors: null,
  isLoading: false,
  proposalData: [],
  jobProposalData:[]
};

const ProposalSlice= createSlice({
    name:"proposal",
    initialState,
      reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setProposalData: (state, action) => {
      state.proposalData = action.payload;
    },
    setJobProposalData:(state, action) =>{
      state.jobProposalData = action.payload;
    }
}
})


export const createProposal =(data)=>async(dispatch)=>{
    dispatch(setLoading(true));
    try{
    let URL = "/proposal";
    const response = await axiosInstance.post(URL,data);

    const { status } = response?.data || {};

    if (status === "success") {
      dispatch(setJobProposalData(response?.data?.data));
    } 

    }catch(error){
      const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(setErrors({
      status: error?.response?.status,
      message: errorMsg,
    }));

    } 
}

export const jobProposals =(workId)=>async(dispatch)=>{
    dispatch(setLoading(true));
 
    try{
    let URL = `/proposal/${workId}`;
    const response = await axiosInstance.get(URL);

    const { status } = response?.data || {};

    if (status === "success") {
      dispatch(setJobProposalData(response?.data?.data));
    } 
  }catch(error){
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(setErrors({
      status: error?.response?.status,
      message: errorMsg,
    }));

}
}


export const{setErrors, setLoading, setProposalData,setJobProposalData }= ProposalSlice.actions;

export default ProposalSlice.reducer;